import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaylist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlaylist"><Path d="M22.0039 4H20.5039V14.1499C19.8593 13.7351 19.0676 13.5 18.2539 13.5C16.3167 13.5 14.5039 14.8328 14.5039 16.75C14.5039 18.6672 16.3167 20 18.2539 20C20.1911 20 22.0039 18.6672 22.0039 16.75V4Z" fill="currentColor"/><Path d="M2 5V6.5H17.01V5H2Z" fill="currentColor"/><Path d="M2 11.25V12.75H12V11.25H2Z" fill="currentColor"/><Path d="M2 17.5V19H10V17.5H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlaylist;
